export type Accent = 'terracotta' | 'indigo' | 'gold' | 'teal' | 'clay' | 'ink'

export interface Volume {
  code: string
  name: string
  subtitle: string
  intro: string
  focus: string[]
  result: string
  accent: Accent
}

export const volumes: Volume[] = [
  {
    code: '01',
    name: 'Visual Language Masterclass',
    subtitle: 'The Foundations of Seeing',
    intro: 'The foundational base that holds everything together.',
    focus: [
      'Line, shape, and form mastery',
      'Color and value theory',
      'Texture, space, and composition',
      'Pattern, rhythm, and contrast',
      'Creative decision-making',
      'Visual analysis framework',
    ],
    result:
      'Your students understand visual language and make stronger creative decisions from day one.',
    accent: 'terracotta',
  },
  {
    code: '02',
    name: 'The Observational Blueprint',
    subtitle: 'Drawing What Is Actually There',
    intro:
      'Develop observation, proportion, structure, and visual confidence.',
    focus: [
      'Line control and contour drawing',
      'Shape and form construction',
      'Observation systems',
      'Comparative measurement',
      'Proportion and negative space',
      'Value and light shading',
    ],
    result:
      'Students stop guessing and start using visible relationships and structure.',
    accent: 'indigo',
  },
  {
    code: '03',
    name: 'Liquid Media & Color Alchemy',
    subtitle: 'Paint, Water, and Control',
    intro:
      'Teach how paint behaves and how to control it professionally.',
    focus: [
      'Watercolor, acrylic, and gouache',
      'Brush control and wash techniques',
      'Wet-on-wet and wet-on-dry methods',
      'Layering and opacity mastery',
      'Edge control and texture',
      'Color mixing and corrections',
    ],
    result:
      'Students gain practical control over color, water, brushes, and painted surfaces.',
    accent: 'gold',
  },
  {
    code: '04',
    name: 'Visual Storytelling & Modern Design',
    subtitle: 'Composition With Intent',
    intro:
      'Teach how to organize information and communicate visually.',
    focus: [
      'Balance and focal point strategy',
      'Hierarchy and framing',
      'Cropping and composition',
      'Movement and rhythm',
      'Contrast and emphasis',
      'Visual storytelling with image and text',
    ],
    result:
      'Students stop filling pages and begin controlling what viewers notice.',
    accent: 'teal',
  },
  {
    code: '05',
    name: '3D Dimensions & Material Lab',
    subtitle: 'Building, Layering, Transforming',
    intro:
      'Move beyond 2D into sculpture, form, and spatial thinking.',
    focus: [
      'Sculpture and 3D form basics',
      'Clay, cardboard, and material mastery',
      'Mixed media and assemblage',
      'Paper construction and origami',
      'Found objects and recycled materials',
      'Installation and spatial art',
    ],
    result:
      'Students learn to build, layer, and transform materials across 2D, 3D, and spatial art.',
    accent: 'clay',
  },
  {
    code: '06',
    name: 'The Master’s Portfolio & Practice',
    subtitle: 'Final Projects, Curation & Exhibition',
    intro:
      'High-level final projects, curation, exhibition, and the step into professional practice.',
    focus: [
      'High-level final projects',
      'Portfolio building and selection',
      'Curating a cohesive body of work',
      'Exhibition and display craft',
      'Artist statements and presentation',
      'Professional and career pathways',
    ],
    result:
      'Students leave with a curated portfolio and a body of work ready to be shown.',
    accent: 'ink',
  },
]
